import { Button as MuiButton, Snackbar, Alert, AlertColor } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Button, Container, Content, ContentBody, ContentInput, ContentInputProfilePhoto, ContentInputProfilePhotoIcon, ContentTitle, Title } from './styles';
import { useNavigate, useParams } from 'react-router-dom';
import { UserPermissions } from '../../../App';


interface Props {
    userPermissions: UserPermissions;
}
const ViewPatients: React.FC<Props> = ({ userPermissions }) => {
    const navigate = useNavigate();
    let { organization } = useParams();
    const [currentOrg, setCurrentOrg] = useState({
        logo: '',
        id: '',
        name: '',
        website: '',
        description: ''
    });

    const hiddenLogoInput = React.useRef<HTMLInputElement>(null);

    const onImageChangeClick = () => {
        if (hiddenLogoInput.current) {
            hiddenLogoInput.current.click();
        }
    };
    const onHiddenLogoInputChange = (event: any) => {
        const fileUploaded = event.target.files[0];

        var reader = new FileReader();
        var baseString;
        reader.onloadend = function () {
            baseString = reader.result;
            changeVar('logo', baseString + '');
        };
        reader.readAsDataURL(fileUploaded);
    };

    const changeVar = (varName: string, value: string) => {
        setCurrentOrg({
            ...currentOrg,
            [varName]: value
        });
        console.log(currentOrg);
    };

    const [showStatus, setShowStatus] = React.useState(false);
    const [statusMsg, setStatusMsg] = React.useState('');
    const [statusSeverity, setStatusSeverity] = React.useState<AlertColor>('error');
    const handleCloseStatus = (event?: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }

        setShowStatus(false);
    };


    const onEditOrganization = () => {

        fetch('/api/v1/organization/edit', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(currentOrg)
        }).then(response => response.json()
        ).then(data => {
            console.log(data);
            if (data.success === true) {
                console.log("Created!");
                setStatusMsg('Organization info was updated! Redirecting in 5 seconds...');
                setStatusSeverity('success');
                setShowStatus(true);
                setTimeout(() => {
                    navigate(process.env.PUBLIC_URL + "/Organizations");
                }, 5000)
            } else {
                console.log("Not updated: ", data.reason);
                setStatusMsg(`Organization info was not updated (${data.reason + ''}). Refresh the page and try again.`);
                setStatusSeverity('error');
                setShowStatus(true);
            }
        });
    }

    const getOrganizations = () => {
        fetch('/api/v1/organization/get', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                id: organization
            })
        }).then(response => response.json()
        ).then(data => {
            if (data?.success === true) {
                delete data.success;
                setCurrentOrg(data);
            }
            console.log(data);
        });
    }

    useEffect(() => {
        getOrganizations();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Container>
            <Title>View Organization <Button onClick={() => {
                onEditOrganization();
                //navigate(process.env.PUBLIC_URL + "/Organizations");
            }}>Save Changes</Button></Title>

            <Content>
                <ContentTitle>{organization}</ContentTitle>

                <ContentBody>
                    <ContentInput label="Organization Name" variant="standard" value={currentOrg.name} onChange={(ev) => changeVar("name", ev.target.value)} />
                    <br />

                    <ContentInput label="Website" variant="standard" style={{ marginBottom: "2rem" }} value={currentOrg.website} onChange={(ev) => changeVar("website", ev.target.value)} />
                    <br />

                    <ContentInput
                        id="standard-multiline-static"
                        label="Description"
                        multiline
                        rows={4}
                        variant="standard"
                        value={currentOrg.description}
                        onChange={(ev) => changeVar("description", ev.target.value)}
                    />
                    <br />

                    <MuiButton
                        variant="contained"
                        style={{
                            position: "absolute",
                            bottom: "20px"
                        }}
                        onClick={() => {
                            //onEditOrganization();
                            navigate(process.env.PUBLIC_URL + "/Organizations/View/" + organization + '/Members');
                        }}
                    >Edit Members</MuiButton>


                    <ContentInputProfilePhoto onClick={onImageChangeClick}>
                        {/* eslint-disable-next-line jsx-a11y/img-redundant-alt */}
                        <img src={currentOrg.logo} alt="Click here to upload a profile photo" />
                        <ContentInputProfilePhotoIcon />
                        <input type="file" ref={hiddenLogoInput} onChange={onHiddenLogoInputChange} style={{ "display": "none" }} />
                    </ContentInputProfilePhoto>
                </ContentBody>
            </Content>
            {/*<div style={{ height: 500, width: '100%', paddingTop: "1rem" }}>

    </div>*/}

            <Snackbar open={showStatus} autoHideDuration={6000} onClose={handleCloseStatus}>
                <Alert onClose={handleCloseStatus} severity={statusSeverity} sx={{ width: '100%' }}>
                    {statusMsg}
                </Alert>
            </Snackbar>
        </Container>
    )
};


export default ViewPatients;